export default "__VITE_ASSET__DwVxqyZz__"